<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >物流&订单管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cSellOrderList' }"
          v-if="state == 'shdj'">销售业务管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cBusinessOrderList' }"
          v-else-if="state == 'sk'">业务订单审核</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cOrderDetail' }"
          >订单详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>订单支付收款管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <div @click="handleDetail('')" v-if="state == 'shdj'" >
            <p class="flex-rowl"><i class="iconfont icon-xinzeng"></i> 添加收款记录</p>
          </div>
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="输入关键字查找→"
              @keyup.enter.native="getOrderPaymentList()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="getOrderPaymentList">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示客户企业列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="(item, index) in dataList" :key="index">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl" @click="handleDetail(item.id)">
                  <div class="block">
                    <p>
                      付款方式：
                      <span>{{ item.paytype }}</span>
                    </p>
                    <p>
                      付款抬头：
                      <span>{{ item.headname }}</span>
                    </p>
                    <p>
                      付款开户行：
                      <span>{{ item.bankname }}</span>
                    </p>
                    <p>
                      付款账号：
                      <span>{{ item.bankaccount }}</span>
                    </p>
                  </div>
                  <div class="block">
                   <p>
                      付款金额：
                      <span>¥ {{ item.paynum | formatPrice }}</span>
                    </p>
                    <p>
                      实际订单价格：
                      <span>¥ {{ dataItem.price | formatPrice }}</span>
                    </p>
                    <!-- <p>
                      剩余差额：
                      <span>¥ {{ item.remain | formatPrice }}</span>
                    </p> -->
                  </div>
                  <div class="block">
                    <p>付款记录创建人：<span>{{ item.createuser }}</span></p>
                    <p>付款记录创建日期：<span>{{ item.createdate | formatDate }}</span></p>
                    
                  </div>
                  <div class="block">
                    <p>付款记录审核人：<span>{{ item.checkuser }}</span></p>
                    <p>付款记录审核日期：<span>{{ item.checkdate | formatDate }}</span></p>
                    <p class="red">付款记录审核状态：<span>{{ item.checkstate }}</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty description="暂无数据" v-else></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->

    <!-- 分页 start -->
    <!-- <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div> -->
    <!-- 分页 end -->
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getOrderPaymentList, getOrderListDetail } from "../../../api/shop";
import { mapState } from "vuex";
export default {
  name: "cPaymentList",
  data() {
    return {
      state: '',  // sk=订单收款管理、sh=订单审核管理
      type: 1,
      dataList: [],
      loading: false,
      params: {
        orderno: "",
        keyword: "",
      },
      orderId: "",
      orderOpenid: "",
      listTotal: 0,

      // 客户标签
      customerOptin: [],
      dataItem: '',  // 订单详情
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
     // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.qyid = USERINFO.qy.qyid;
    } else {
      this.qyid = 0;
    }

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { orderno, orderId, orderOpenid, state } = JSON.parse(res.jsondata);
        this.orderId = orderId;
        this.orderOpenid = orderOpenid;
        this.params.orderno = orderno;
        this.state = state
        this.getOrderPaymentList();
        this.getOrderListDetail(orderId, orderOpenid)
      } else {
        this.$router.back();
      }
    },

    // 分页
    handleCurrentChange(e) {
      this.params.pageindex = e;
      this.getOrderPaymentList();
    },

    // 重置数据
    handleRest() {
      this.params.pageindex = 1;
      this.params.keyword = "";
      this.getOrderPaymentList();
    },

    // 获取数据
    getOrderPaymentList() {
      this.loading = true;
      getOrderPaymentList(this.params).then((res) => {
        res.list.sort((a, b) => b.createdate.localeCompare(a.createdate))
        this.dataList = res.list;
        this.listTotal = res.total;
        this.loading = false;
      });
    },

    // 订单列表
    getOrderListDetail(id, openid) {
      let params = {
        openid: openid,
        orderid: id,
      };
      this.loading = true;
      getOrderListDetail(params).then((res) => {
        let newObj = res[0];
        this.dataItem = newObj;
      });
    },

    handleDetail(id) {
      let { orderno } = this.params;
      let { orderId, orderOpenid, state } = this;
      if (id) {
        this.encryptstringadd("cPaymentDetail", {
          orderno,
          id,
          orderId,
          orderOpenid,
          type: state == 'shdj' ? 1 : 2
        });
        // this.$router.push({ path: "/brandIndex/brandDetail", query: { id } });
      } else {
        this.encryptstringadd("cPaymentDetail", {
          orderno,
          id: "",
          orderId,
          orderOpenid,
          type: state == 'shdj' ? 1 : 2
        });
      }
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .operation_wrap {
    .screen_wrap {
      font-size: 14px;
      .sort_wrap {
        border: 1px solid #d8d8d8;
        border-radius: 20px;
        height: 35px;
        padding: 0 10px;
        margin-right: 10px;
      }
      .select_wrap {
        margin-right: 10px;
      }
      .icon-24gl-swapHorizontal {
        transform: rotate(90deg);
      }
    }
  }
  .list_wrap {
    .item_main_wrap {
      .address_wrap {
        width: 28%;
      }
      .customer_wrap {
        span {
          height: 40px;
          border: 1px solid #d2d2d2;
          font-size: 12px;
          padding: 0 10px;
          margin-right: 5px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .intro_box {
        cursor: pointer;
      }
    }
    .red {
      color: #ff0036;
    }
  }
}
</style>